import { BiArrowBack } from "react-icons/bi";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
// import ReportedContent from "./reportedContent";
// import ContactUs from "./contactUsQuery";
import classNames from "classnames";
import AuthContext from "context/AuthContext";
import List from "./insuranceServiceList";
import ServiceProviders from "./serviceProviderList";
import { isEmpty } from "lodash";

const tabBtnClass =
  "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-lime-500 text-lime-500";
const tabBorderNoneClass = "border-transparent";
const TAB_LIST = "list";
const TAB_SERVICE_PROVIDER = "service-provider";

function InsuranceManager({ data,
    page,
    setPage,
    sort,
    setSort,
    manager,
    getServiceListData,
    paginationObj,
    handlePageClick,
    setItem,
    insuranceServiceId,
 }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
//   const [serviceListData, setServiceListData] = useState(
//     !isEmpty(location.state?.getServiceListData)
//       ? location.state?.getServiceListData
//       : getServiceListData
//       );
      const { logoutUser, user } = useContext(AuthContext);
//   const [paginationObj, setPaginationObj] = useState({
//     page: 1,
//     pageCount: 1,
//     pageRangeDisplayed: 10,
//   });
  const [users, setAllUser] = useState([]);
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
//   const [sort, setSort] = useState({
//     sort_key: "createdAt",
//     sort_type: "desc",
//   });
//   const manager = user?.permission?.find((e) => e.manager === "service-provider") ?? {};
  const [defaultTab, setDefaultTab] = useState(
    location?.state?.tabFrom === "service-provider" ? "service-provider" : "list"
  );
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  //   const [item, setItem] = useState(location?.state?.item)

  return (
    <>
      <div className="bg-[#F9F9F9]">
        <div className="">
          <div className="bg-white rounded-lg">
            <div className="pt-4">
              <div className="flex border-b justify-between">
                <div className="">
                  <ul className="flex">
                    <li className="mr-0 xl:mr-5">
                      <button
                        onClick={handleTabClick.bind(this, TAB_LIST)}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_LIST,
                          [tabBorderNoneClass]: defaultTab !== TAB_LIST,
                        })}
                      >
                        {t("O_REQUEST_LISTING")}
                      </button>
                    </li>
                    <li className="mx-0 xl:mx-5">
                      <button
                        onClick={handleTabClick.bind(this, TAB_SERVICE_PROVIDER)}
                        className={classNames({
                          [tabBtnClass]: true,
                          [tabActiveClass]: defaultTab === TAB_SERVICE_PROVIDER,
                          [tabBorderNoneClass]: defaultTab !== TAB_SERVICE_PROVIDER,
                        })}
                      >
                        {t("O_SERVICE_PROVIDERS")}
                      </button>
                    </li>
                  </ul>
                </div>
               <div>

               </div>
              </div>
              {defaultTab === TAB_LIST ? (
                <List data={data} getServiceListData={getServiceListData} setItem={setItem} page={page} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData} />
              ) : (
                <ServiceProviders insuranceServiceId={insuranceServiceId} page={page} setPage={setPage} setSort={setSort} sort={sort} paginationObj={paginationObj} handlePageClick={handlePageClick} filterData={filterData} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InsuranceManager;
